import {
    VIEWDEALERFORPARTNER_SUCCESS,
    VIEWDEALERFORPARTNER_FAILED,
    RESET_VIEWDEALERFORPARTNER,
    LOADING_VIEWDEALERFORPARTNER,
    NETWORK_ERROR_VIEWDEALERFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetVIEWDEALERFORPARTNER = () => {
    return { type: RESET_VIEWDEALERFORPARTNER };
};

const partnerViewDealerReqList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_VIEWDEALERFORPARTNER });
    await partnerServices
        .post("viewDealer", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerViewDealerReqListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerViewDealerReqListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_VIEWDEALERFORPARTNER,
                payload: err
            });
        });
};

function partnerViewDealerReqListsuccess(data) {
    return {
        type: VIEWDEALERFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerViewDealerReqListFailed(data) {
    return {
        type: VIEWDEALERFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetVIEWDEALERFORPARTNER, partnerViewDealerReqList }